import React from 'react';
import "../css/Presentational.css"
import LanguageChange from "../components/LanguageChange"
import { Image } from 'semantic-ui-react';
import mainImage from "../img/main.jpg";
import mainImage2 from "../img/main2.jpg";
import mainImage3 from "../img/main3.jpg";
import mainImage4 from "../img/main4.jpg";
import mainImage5 from "../img/main5.jpg";
import mainImage6 from "../img/main6.jpg";
import mainImage7 from "../img/main7.jpg";



const Presentational = () => {
    return (
        <div className="presentational">
            <LanguageChange />
            <Image src={mainImage7} size='' />
            
        </div>
    )
}

export default Presentational
